import Complete from "./Complete";
import Delete from "./Delete";
import ProcrastinatedDays from "./ProcrastinatedDays";
import Pull from "./Pull";
import Push from "./Push";
import Uncomplete from "./Uncomplete";

const Task = ({ id, text, complete, created, pushed }) => {
  let className = "task-text";
  if (complete) {
    className += " task-complete";
  }

  return (
    <div className="task-container">
      <div className="task-text-container">
        <span className={className}>{text}</span>
        <ProcrastinatedDays
          complete={complete}
          created={created}
          pushed={pushed}
        ></ProcrastinatedDays>
      </div>
      <div className="task-buttons">
        <Delete id={id} complete={complete}></Delete>
        <Push id={id} complete={complete} pushed={pushed}></Push>
        <Pull id={id} complete={complete} pushed={pushed}></Pull>
        <Complete id={id} complete={complete} pushed={pushed}></Complete>
        <Uncomplete id={id} complete={complete}></Uncomplete>
      </div>
    </div>
  );
};

export default Task;
